import { Avatar, type IColumn, IconButton, Tooltip, Typography } from 'shared/ui'
import { EmptyCell } from 'shared/ui/TableNew'
import { DayjsFormats, getLabelAsNumberInternationalFormat } from 'shared/lib'
import { uiStore } from 'shared/store/uiStore'
import { NpsScoreBadge } from 'entities/Surveys'
import { type SurveyContactRow } from 'entities/Surveys/model/Table/SurveyContactRow'
import { getCellForTags } from 'widgets/ContactEnrollment/ui/EnrollmentContactsTable'
import type { IOpenContactsDetails } from 'widgets/ContactsDetails'
import styles from './styles.module.scss'

export const columns = (
  onOpenContactsDetails: IOpenContactsDetails
): IColumn<SurveyContactRow>[] => {
  return [
    {
      field: 'contact_name',
      name: 'Name',
      isDisabledChangeVisible: true,
      isSortable: true,
      width: '100%',
      minWidth: 266,
      maxWidth: 266,
      renderRowCell: ({ fullName, avatarInfo, contact_id, isDeleted }, _, config) => (
        <div className={styles.contactColumn}>
          <div className={styles.contactColumnName}>
            <Avatar info={avatarInfo} size={24} />
            {fullName ? (
              <Typography
                variant={'body-md-regular'}
                ariaLabel={'SurveyContactName'}
                ellipsis
                tooltipProps={{
                  label: fullName,
                  breakWord: true,
                }}
              >
                {fullName}
              </Typography>
            ) : (
              <EmptyCell />
            )}
          </div>

          {!isDeleted && (
            <Tooltip label='Conversation' placement='top'>
              <IconButton
                icon='conversation'
                variant='icon'
                color='tertiary'
                transparentInactive
                className={config?.hidden}
                ariaLabel='ContactRow_sendMessage'
                disabled={onOpenContactsDetails.disabled || contact_id === null}
                onClick={(event) => {
                  event.stopPropagation()

                  if (contact_id === null) return

                  onOpenContactsDetails.open({
                    contactId: contact_id,
                  })
                }}
              />
            </Tooltip>
          )}
        </div>
      ),
    },
    {
      field: 'contact_phone',
      name: 'Number',
      width: '129px',
      minWidth: '129px',
      renderRowCell: ({ formattedNumber }) =>
        formattedNumber ? (
          <Typography variant={'body-md-regular'} ariaLabel={'SurveyContactNumber'}>
            {getLabelAsNumberInternationalFormat(formattedNumber)}
          </Typography>
        ) : (
          <EmptyCell />
        ),
    },
    {
      field: 'sent_at',
      name: 'Send time',
      width: '170px',
      minWidth: '170px',
      renderRowCell: ({ sent_at }) => (
        <Typography variant={'body-md-regular'} ariaLabel={'SurveyContactSendTime'}>
          {uiStore.dayjs(sent_at).format(DayjsFormats.fullWithAtDash)}
        </Typography>
      ),
    },
    {
      field: 'nps_score',
      name: 'Score',
      width: '80px',
      renderRowCell: ({ score }) =>
        score !== null ? <NpsScoreBadge score={score} /> : <EmptyCell />,
    },
    {
      field: 'feedback_text',
      name: 'Feedback',
      width: '39%',
      minWidth: 290,
      maxWidth: 435,
      renderRowCell: ({ comment }) =>
        comment ? (
          <Typography variant={'body-md-regular'} ariaLabel={'SurveyContactFeedback'} ellipsis>
            {comment}
          </Typography>
        ) : (
          <EmptyCell />
        ),
    },
    {
      field: 'tags',
      name: 'Tags',
      renderRowCell: (row) => getCellForTags({ tags: row.tags, isDisabled: row.isDisabled }),
    },
  ]
}
